import Head from "next/head";
import { FunctionComponent } from "react";

import { Button } from "@/components";

const Referrals: FunctionComponent = () => (
  <>
    <Head>
      <title>BankX - Referral Resources</title>
    </Head>
    <section className="column-3 column-span-7 row-1">
      <h1 className="balance">Referral Resources</h1>
      <nav>
        <Button href="https://www.dropbox.com/scl/fo/ymgvkg0vormfzutzq1zau/AH_2LJFKiiyWtU-9GC1PBHQ?rlkey=scalwxcncji0qn0p053niw5c1&dl=0">
          Click Here
        </Button>
      </nav>
    </section>
  </>
);

export default Referrals;
